// extracted by mini-css-extract-plugin
module.exports = {"image":"StatusIcon__image--2rv","icon":"StatusIcon__icon--1cE"};